@if (helpService.isOpen()) {
  <!-- Overlay backdrop for mobile -->
  <div class="hp-backdrop" (click)="helpService.close()"></div>

  <aside class="hp-panel" [style.width.px]="helpService.panelWidth()" role="complementary" aria-label="Contextual help">
    <!-- Resize handle -->
    <div class="hp-resize-handle" (mousedown)="onResizeStart($event)"></div>

    <!-- Header -->
    <div class="hp-header">
      <div class="hp-header-title">
        <i class="pi pi-question-circle" aria-hidden="true"></i>
        <span>Help</span>
      </div>
      <button class="hp-close-btn" (click)="helpService.close()" aria-label="Close help panel">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>

    <!-- Scrollable content -->
    <div class="hp-content" #chatContainer>
      <!-- Loading state -->
      @if (helpService.isLoading() && !helpService.summary()) {
        <app-skeleton shape="card" [count]="1" [showAvatar]="false" [lines]="5" [badges]="0" [showFooter]="false" ariaLabel="Loading help…" />
      }

      <!-- Error state -->
      @if (helpService.error()) {
        <div class="hp-error">
          <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
          <p>{{ helpService.error() }}</p>
          <button class="hp-retry-btn" (click)="retry()">Retry</button>
        </div>
      }

      <!-- Empty state — no summary, not loading, no error -->
      @if (!helpService.isLoading() && !helpService.summary() && !helpService.error()) {
        <div class="hp-empty">
          <i class="pi pi-sparkles" aria-hidden="true"></i>
          <p>Get AI-generated help for this page</p>
          <button class="hp-retry-btn" (click)="retry()">Load Help</button>
        </div>
      }

      <!-- About this page -->
      @if (helpService.summary()) {
        <div class="hp-section">
          <h4 class="hp-section-title">About this page</h4>
          <div class="hp-summary" [innerHTML]="helpService.summary() | hpMarkdown"></div>
        </div>
      }

      <!-- Chat messages -->
      @if (helpService.messages().length > 0) {
        <div class="hp-section">
          <h4 class="hp-section-title">Conversation</h4>
          @for (msg of helpService.messages(); track $index) {
            <div class="hp-message" [class.hp-message-user]="msg.type === 'user'" [class.hp-message-ai]="msg.type === 'ai'">
              <div class="hp-message-content" [innerHTML]="msg.type === 'ai' ? (msg.content | hpMarkdown) : msg.content"></div>
            </div>
          }
        </div>
      }

      <!-- Typing indicator -->
      @if (helpService.isLoading() && helpService.summary()) {
        <div class="hp-typing">
          <span></span><span></span><span></span>
        </div>
      }
    </div>

    <!-- Chat input -->
    <div class="hp-input-area">
      <textarea
        class="hp-input"
        [(ngModel)]="chatInput"
        (keydown)="onKeydown($event)"
        placeholder="Ask a question about this page..."
        rows="1"
        aria-label="Ask a question"
      ></textarea>
      <button class="hp-send-btn" (click)="onSend()" [disabled]="!chatInput.trim()" aria-label="Send message">
        <i class="pi pi-send" aria-hidden="true"></i>
      </button>
    </div>
  </aside>
}
